import type { TOC } from '@ember/component/template-only';

import BarLoader from 'webapp/components/bar-loader';

interface CustomQuerySetupSheetLoaderInterface {
	Element: HTMLDivElement;
}

const CustomQuerySetupSheetLoader: TOC<CustomQuerySetupSheetLoaderInterface> = <template>
	<div class="sheet-loading">
		<BarLoader />
		<p>Reloading sheet...</p>
	</div>
</template>;

export default CustomQuerySetupSheetLoader;
